export const setup = (element, prefix = 'Imagem: ') => {
  const copyright = element.dataset.copyright;

  const copyrightCaption = document.createElement('small');
  copyrightCaption.classList.add('copyright', 'text-caption', 'font-caption');
  copyrightCaption.innerHTML = `${prefix} ${copyright}`;

  element.appendChild(copyrightCaption);
};
